export const CREATE_HISTORY = "CREATE_HISTORY";
export const CREATE_HISTORY_SUCCESS = "CREATE_HISTORY_SUCCESS";
